<template>
  <div class="ui grid">
    <div class="row">
      <h1 class="ui huge header">Test report</h1>
    </div>
    <div class="row">
      <p>
        Select either an existing test or school to start the process of
        generating a test report. Click the button below to restart the process.
      </p>
    </div>
    <div class="row">
      <sui-button type="button" negative v-on:click="reset">
        Restart process
      </sui-button>
    </div>
    <div class="row">
      <sui-dropdown v-bind:disabled="selectedSchool !== null" fluid :options="testSelection" placeholder="Select test"
        search selection v-model="selectedTestId" />
    </div>
    <div class="row">
      <sui-dropdown v-bind:disabled="selectedTestId !== null" fluid :options="schoolSelection"
        placeholder="Select school" search selection v-model="selectedSchool" />
    </div>
    <div class="row" v-if="selectedSchool !== null">
      <sui-dropdown fluid :options="teacherSelection" placeholder="Select teacher" search selection
        v-model="selectedTeacher" />
    </div>
    <div class="row" v-if="selectedTeacher != null">
      <sui-dropdown fluid :options="classSelection" placeholder="Select class" search selection
        v-model="selectedClass" />
    </div>
    <test-student-matrix v-if="showMatrix" v-bind:students="students" v-bind:choices="choices" v-bind:new="newTest"
      v-on:updated="choicesUpdated" />
    <div v-if="createTestError" class="ui negative message">
      <p>{{ createTestError }}</p>
    </div>
    <div class="row" v-if="selectedClass">
      <sui-button type="button" positive icon="thumbs up" v-on:click="submit">
        Create report
      </sui-button>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import moment from 'moment';
import TestStudentMatrix from './TestStudentMatrix';

export default {
  name: 'TestVerification',
  components: { TestStudentMatrix },
  computed: {
    schoolSelection() {
      // eslint-disable-next-line arrow-parens
      return this.schools.map((school) => ({
        key: school.id,
        value: school.rollNumber,
        text: `${school.name} (${school.rollNumber})`,
      }));
    },
    classSelection() {
      // eslint-disable-next-line arrow-parens
      return this.classes.map((cls) => ({
        key: cls.id,
        value: cls.id,
        text: cls ? cls.name : 'N/A',
      }));
    },
    teacherSelection() {
      // eslint-disable-next-line arrow-parens
      return this.teachers.map((cls) => ({
        key: cls.id,
        value: cls.id,
        text: cls.email,
      }));
    },
    testSelection() {
      // eslint-disable-next-line arrow-parens
      return this.tests.map((test) => ({
        key: test.id,
        value: test.id,
        text: `class: ${test.class ? test.class.name : 'N/A'}, code: ${test.code
          }, created on: ${moment(test.createdOn).format('DD-MM-YYYY HH:mm:ss')}`,
      }));
    },
    ...mapGetters({
      schools: 'schools',
      classes: 'classes',
      teachers: 'teachers',
      classStudents: 'classStudents',
      tests: 'tests',
      selectedTest: 'selectedTest',
    }),
  },
  data() {
    return {
      selectedSchool: null,
      selectedTeacher: null,
      selectedClass: null,
      selectedTestId: null,
      students: null,
      choices: null,
      updatedChoices: null,
      createTestError: null,
      newTest: true,
      showMatrix: false,
    };
  },
  methods: {
    submit() {
      this.$store
        .dispatch('createTest', {
          classId: this.selectedClass,
          choices: this.updatedChoices,
        })
        .then(
          (response) => {
            this.$router.push(`/test/result/${response.data}`);
          },
          (error) => {
            this.createTestError = error.response.data;
          },
        );
    },
    reset() {
      this.showMatrix = false;
      this.selectedSchool = null;
      this.selectedClass = null;
      this.selectedTeacher = null;
      this.selectedTestId = null;
    },
    choicesUpdated(choices) {
      this.updatedChoices = JSON.parse(JSON.stringify(choices));
    },
    mapToNumber(choice) {
      switch (choice) {
        case 'Like':
          return 3;
        case 'Neutral':
          return 2;
        default:
          return 1;
      }
    },
  },
  created() {
    this.$store.dispatch('getSchools');
    this.$store.dispatch('getTestsMinimum');
  },
  watch: {
    selectedSchool(val) {
      this.selectedTeacher = null;
      this.selectedClass = null;
      this.showMatrix = false;
      if (val) {
        this.$store.dispatch('getTeachers', val);
      }
    },
    selectedTeacher(val) {
      this.selectedClass = null;
      this.showMatrix = false;
      if (val) {
        this.$store.dispatch('getClassesBySchoolCode', val);
      }
    },
    selectedClass(val) {
      if (val) {
        if (this.selectedTestId === null) {
          this.newTest = true;
          this.$store.dispatch('getClassStudentsById', val).then(() => {
            this.students = JSON.parse(JSON.stringify(this.classStudents));
            this.showMatrix = true;
          });
        }
      }
    },
    selectedTestId(val) {
      if (val) {
        this.$store.dispatch('getTest', val).then(() => {
          this.newTest = false;
          this.students = this.selectedTest.students.map(
            // eslint-disable-next-line arrow-parens
            (student) => student.student,
          );
          this.students = Object.assign({}, this.students);

          this.choices = {};
          // eslint-disable-next-line arrow-parens
          this.selectedTest.students.forEach((student) => {
            this.choices[student.student.id] = {};
            // eslint-disable-next-line arrow-parens
            student.choices.forEach((choice) => {
              this.choices[student.student.id][choice.targetStudent.id] =
                this.mapToNumber(choice.choice);
            });
          });
          this.selectedClass = this.selectedTest.class.id;
          this.showMatrix = true;
        });
      }
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/tests/TestVerification.vue